import { render } from "./MismatchIntents.vue?vue&type=template&id=15154a4f&scoped=true"
import script from "./MismatchIntents.vue?vue&type=script&lang=js"
export * from "./MismatchIntents.vue?vue&type=script&lang=js"

import "./MismatchIntents.vue?vue&type=style&index=0&id=15154a4f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15154a4f"]])

export default __exports__